module.exports = __webpack_public_path__ + "static/media/contact-liftup-1.36f7d658.jpg";